import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { defaultPincodeData, getPincodeById, updatePincode, createPincode } from '@/api/pincode';
import { AppModule } from '@/store/modules/app';
import { TagsViewModule } from '@/store/modules/tags-view';
import router from '@/router';
import { Action } from 'vuex-module-decorators';
import { getQuery } from '@/utils';
import { getCountries } from '@/api/locations/countries';
import { getStates } from '@/api/locations/states';
import { getCities, getCityById } from '@/api/locations/cities';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.countryList = [];
    this.stateList = [];
    this.cityList = [];
    this.validateRequire = (rule, value, callback) => {
      if (value === '') {
        if (rule.field === 'imageURL') {
          this.$message({
            message: 'Upload cover image is required',
            type: 'error'
          });
        } else {
          this.$message({
            message: rule.field + ' is required',
            type: 'error'
          });
        }
        callback(new Error(rule.field + ' is required'));
      } else {
        callback();
      }
    };
    this.formData = Object.assign({}, defaultPincodeData);
    this.loading = false;
    this.rules = {
      pincodeName: [{
        required: true,
        message: 'Please enter Pincode',
        trigger: 'blur'
      }, {
        min: 3,
        max: 150,
        message: 'Length should be 3 to 150',
        trigger: 'blur'
      }],
      pincode: [{
        required: true,
        message: 'Please enter Pincode',
        trigger: 'blur'
      }, {
        min: 6,
        max: 6,
        message: 'Length should be 6',
        trigger: 'blur'
      }],
      homeDeliveryCharges: [{
        required: true,
        message: 'Please enter Charges',
        trigger: 'blur'
      }]
    };
  }
  get lang() {
    return AppModule.language;
  }
  activated() {
    // this.getCountryList()
    if (this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      this.fetchData(parseInt(id));
    } else {
      this.formData = Object.assign({}, defaultPincodeData);
      this.formData.cityId = parseInt(this.$route.params && this.$route.params.cityId);
      this.fetchCity(this.formData.cityId);
    }
    this.tempTagView = Object.assign({}, this.$route);
  }
  async fetchData(id) {
    try {
      const data = await getPincodeById(id);
      this.formData = data;
      // Just for test
      const title = this.formData.pincodeName;
      // Set tagsview title
      this.setTagsViewTitle(title);
      // Set page title
      this.setPageTitle(title);
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async fetchCity(id) {
    try {
      const cityData = await getCityById(id);
      this.formData.stateId = cityData.stateId;
      // this.formData.countryId = cityData.countryId
    } catch (err) {} // eslint-disable-line  no-empty
  }
  async getCountryList() {
    try {
      this.getStateList();
      this.countryList = await getCountries(getQuery({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getStateList() {
    try {
      this.getCityList();
      this.stateList = await getStates(getQuery({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {
      Promise.reject(err);
    }
  }
  async getCityList() {
    try {
      this.cityList = await getCities(getQuery({
        enabled: true,
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (err) {
      Promise.reject(err);
    }
  }
  setTagsViewTitle(title) {
    const tagView = this.tempTagView;
    if (tagView) {
      tagView.title = `${title}-${this.formData.id}`;
      TagsViewModule.updateVisitedView(tagView);
    }
  }
  setPageTitle(title) {
    document.title = `${title} - ${this.formData.id}`;
  }
  submitForm() {
    this.$refs.formData.validate(valid => {
      if (valid) {
        this.saveForm();
      } else {
        return false;
      }
    });
  }
  resetForm() {
    this.$refs.formData.resetFields();
  }
  async saveForm() {
    try {
      this.loading = true;
      if (this.isEdit) {
        this.formData.state.id = this.formData.stateId;
        this.formData.city.id = this.formData.cityId;
        await updatePincode(this.formData.id, this.formData);
      } else {
        delete this.formData.country;
        delete this.formData.state;
        delete this.formData.city;
        await createPincode(this.formData);
      }
      this.loading = false;
      this.$notify({
        title: 'Success',
        message: 'Pincode saved successfully',
        type: 'success',
        duration: 2000
      });
      router.push({
        path: '/pincode/list/' + this.formData.cityId,
        query: this.$route.query
      });
    } catch (err) {
      this.loading = false;
    }
  }
};
__decorate([Prop({
  default: false
})], default_1.prototype, "isEdit", void 0);
__decorate([Action], default_1.prototype, "saveForm", null);
default_1 = __decorate([Component({
  name: 'PincodeDetail',
  components: {}
})], default_1);
export default default_1;